module.exports = __webpack_public_path__ + "img/527.7c139614.jpg";